import preferencesConfigAction from './preferencesConfig.action';
import preferencesConfigBatchAction from './preferencesConfigBatch.action';

export { preferencesConfigBatchAction };
export default preferencesConfigAction;
